import type { LaunchCampaignTargetingWire } from "../interfaces/adsManagerGuidedEdit";

/** Backend mirror of dashboard `hasManualAudienceTargetingSignal` plus `enabled_strategy_ids`. */
export function hasAnyTargetingSignal(
  t: LaunchCampaignTargetingWire
): boolean {
  if ((t.custom_audiences?.length ?? 0) > 0) return true;
  if ((t.interests?.length ?? 0) > 0) return true;
  const loc = t.locations;
  if (loc) {
    if ((loc.countries?.length ?? 0) > 0) return true;
    if ((loc.geo_markets?.length ?? 0) > 0) return true;
    if ((loc.regions?.length ?? 0) > 0) return true;
    if ((loc.cities?.length ?? 0) > 0) return true;
  }
  const d = t.demographics ?? {};
  if (d.age_min != null && d.age_min !== 18) return true;
  if (d.age_max != null && d.age_max !== 65) return true;
  const g = d.genders;
  if (typeof g === "string" && g !== "" && g !== "all") return true;
  if (
    Array.isArray(g) &&
    g.length > 0 &&
    !(
      g.length === 1 &&
      String(g[0] ?? "")
        .trim()
        .toLowerCase() === "all"
    )
  ) {
    return true;
  }
  if ((t.enabled_strategy_ids?.length ?? 0) > 0) return true;
  return false;
}

/** True when manual slice has audiences, interests, locations, demographics, etc. — not `enabled_strategy_ids` alone. */
export function hasManualTargetingSliceExcludingStrategies(
  t: LaunchCampaignTargetingWire
): boolean {
  return hasAnyTargetingSignal({ ...t, enabled_strategy_ids: [] });
}
